import React, { useCallback, useState } from 'react';
import { styled } from '@mui/material';
import ClearIcon from '@/components/icons/CancelCross';

export type Props = {
  value: string,
  placeholder: string,
  onChange: (value: string) => void,
};

const Container = styled('div')({
  display: 'inline-flex'
});

const Input = styled('input')({
  width: '380px',
  border: '1px solid #C1C7D0',
  borderRight: 'none',
  borderTopLeftRadius: '4px',
  borderBottomLeftRadius: '4px',
  color: '#091E42',
  outline: 'none',
  padding: '8px 0 8px 10px',
});

const ClearButton = styled('button')({
  cursor: 'pointer',
  width: '32px',
  height: '32px',
  background: 'transparent',
  color: '#C1C7D0',
  border: '1px solid #C1C7D0',
  borderLeft: 'none',
  borderTopRightRadius: '4px',
  borderBottomRightRadius: '4px',
  padding: '7px',
  '&:disabled': {
    color: 'transparent',
  }
});

export default ({ placeholder, value, onChange }: Props) => {
  const [to] = useState<{ timer: number | null}>({ timer: null });

  const [curVal, setCurVal] = useState(value);

  const onInputChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (to.timer) clearTimeout(to.timer);
      to.timer = window.setTimeout(() => {
        onChange(e.target.value)
      }, 300);
      setCurVal(e.target.value);
    },
    [ onChange, value ]
  );

  const onClear = useCallback(
    () => {
      setCurVal('');
      onChange('');
    },
    [ onChange ]
  );

  return <Container>
    <Input
      placeholder={placeholder}
      value={curVal}
      onChange={onInputChangeHandler}
    />
    <ClearButton disabled={!value} onClick={onClear}><ClearIcon size={18}/></ClearButton>
  </Container>;
};